import React from 'react';
import './IconOwnerLike.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/pro-solid-svg-icons';

const IconOwnerLike = ({avatar}) => {
  return (
    <div className="icon-owner-like-wrapper">
        <FontAwesomeIcon className="icon-owner-like" icon={faHeart}/>
      <img src={avatar} alt="avatar du créateur de la publication" />
    </div>
  );
};

export default IconOwnerLike;
